const isProdEnv = process.env.NODE_ENV === 'production'

const sendConversionMetric = async queryParams => {
  if (isProdEnv && navigator.sendBeacon) {
    navigator.sendBeacon(`/apiui/sendLDMetrics/?${queryParams.toString()}`)
  }
}
export default sendConversionMetric
